import {
  Avatar,
  Box,
  Container,
  Grid,
  FormLabel,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import React from "react";
import Sheet from "@mui/joy/Sheet";
import Radio, { radioClasses } from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import saved from "../../assets/sound/saved.wav";
import trash from "../../assets/sound/trash.mp3";
import { CheckCircle, Delete, Save } from "@mui/icons-material";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";

const BankForm = ({
  id,
  setId,
  setOpenBank,
  cash,
  setCash,
  cashApp,
  setCashApp,
  zelle,
  setZelle,
  card,
  setCard,
  other,
  setOther,
  expense,
  setExpense,
  description,
  setDescription,
  location,
  setLocation,
  textButton,
  operation,
  user,
  setUser,
  date,
  setDate,
}) => {
  const current = new Date();
  const day = `${current.getDate()}`;
  const month = `${current.getMonth() + 1}`;
  const year = `${current.getFullYear()}`;
  const m = month < 10 ? "0" + month : month;
  const d = day < 10 ? "0" + day : day;
  const y = year.substring(2, 4);
  const date1 = year + "-" + m + "-" + d;
  const date2 = m + y + "-" + d;

  const updateRegister = async () => {
    const userDoc = doc(db, "register", id);

    const newFields = {
      date: date1,
      fullDate: date2,
      user: user,
      cash: cash,
      cashApp: cashApp,
      zelle: zelle,
      card: card,
      other: other,
      expense: expense,
      description: description,
      location: location,
    };
    await updateDoc(userDoc, newFields);
    window.location.reload();
  };

  const handleOnSubmit = () => {
    if (operation === "new") {
      createRegister();
      createPettyCash();
    } else {
      updateRegister();
    }
    new Audio(saved).play();
    setOpenBank(false);
  };

  const handleImg = (props) => {
    switch (props.value) {
      case "store":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/store.png?alt=media&token=3eb9f9f5-cbbb-44c0-9e2f-a93c13d6bacd";
      case "van":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/van.png?alt=media&token=6fe6cd9d-5661-4c07-948b-c970dbd84c5e";
      case "web":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/web.png?alt=media&token=590439c9-8de2-4c81-b533-354dc659364f";
      case "amazon":
        return "https://firebasestorage.googleapis.com/v0/b/pydb-ce2bb.appspot.com/o/amazon.png?alt=media&token=20143abb-5342-4a1a-a275-dc16d7b3fb75";
      default:
        return "";
    }
  };

  const createRegister = async () => {
    const regRef = collection(db, "register");

    await addDoc(regRef, {
      date: date,
      user: user,
      cash: cash,
      cashApp: cashApp,
      zelle: zelle,
      card: card,
      other: other,
      expense: expense,
      description: description,
      location: location,
    });
  };

  const createPettyCash = async () => {
    const cashRef = collection(db, "pettyCash");

    const total =
      Number(cash) - (Number(cashApp) + Number(zelle) + Number(other));
    const desc = location + "Cash sale";
    if (total === 0) {
    } else {
      await addDoc(cashRef, {
        date: date,
        description: desc,
        amount: total,
      });
    }
  };

  const handleOnDelete = async () => {
    const userDoc = doc(db, "register", id);
    deleteDoc(userDoc);
    new Audio(trash).play();
    //window.location.reload();
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={1} sm={12}>
        <Typography variant="h6" sx={{ color: "purple" }}>
          Register
        </Typography>
      </Grid>
      <Box padding={1.5}>
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: "flex", gap: 6 }}>
            <RadioGroup
              aria-label="platform"
              defaultValue="store"
              overlay
              name="platform"
              sx={{
                flexDirection: "row",
                gap: 2,
                [`& .${radioClasses.checked}`]: {
                  [`& .${radioClasses.action}`]: {
                    inset: -1,
                    border: "3px solid",
                    borderColor: "primary.500",
                  },
                },
                [`& .${radioClasses.radio}`]: {
                  display: "contents",
                  "& > svg": {
                    zIndex: 2,
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    bgcolor: "background.body",
                    borderRadius: "50%",
                  },
                },
              }}
            >
              {["store", "van", "web", "amazon"].map((value) => (
                <Sheet
                  key={value}
                  variant="outlined"
                  sx={{
                    borderRadius: "md",
                    bgcolor: "background.body",
                    boxShadow: "sm",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1.5,
                    p: 2,
                    minWidth: 120,
                  }}
                >
                  <Radio
                    id={value}
                    value={value}
                    checked={value === location}
                    onChange={(e) => setLocation(e.target.value)}
                    checkedIcon={<CheckCircle />}
                  />

                  <Avatar variant="soft" size="sm" src={handleImg({ value })} />

                  <FormLabel htmlFor={value}>{value}</FormLabel>
                </Sheet>
              ))}
            </RadioGroup>
          </Box>
        </Grid>
      </Box>

      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              value={date}
              label="Date"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              label="User"
              value={user}
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setUser(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              label="Cash"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              value={cash}
              onChange={(e) => {
                setCash(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              label="Cashapp"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              value={cashApp}
              onChange={(e) => {
                setCashApp(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              label="Zelle"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              value={zelle}
              onChange={(e) => {
                setZelle(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              label="Card"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              value={card}
              onChange={(e) => {
                setCard(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              label="Paypal"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              value={other}
              onChange={(e) => {
                setOther(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              label="Expense"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              value={expense}
              onChange={(e) => {
                setExpense(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={1} sm={12}>
            <TextField
              fullWidth
              type="text"
              color="primary"
              label="Description"
              value={description}
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
            />
          </Grid>
          <Grid
            item
            xs={1}
            sm={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <IconButton
              onClick={handleOnSubmit}
              variant="outlined"
              color="primary"
            >
              <Save sx={{ width: 30, height: 30 }} />
            </IconButton>

            <IconButton
              onClick={handleOnDelete}
              variant="outlined"
              color="secondary"
            >
              <Delete sx={{ width: 30, height: 30 }} />
            </IconButton>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default BankForm;
